import React, { ComponentProps } from 'react';

import { Box, HStack, VStack } from '@rbilabs/universal-components';
import { Typography, withTypography } from 'ucl/components/text/Typography';

import ActionButton from 'components/action-button';
import { primitive } from 'styles/constants';

type ImageSize = 'small' | 'medium' | 'large' | 'extraLarge';

const ImageSizeMap: Record<ImageSize, string> = {
  small: '55px',
  medium: '60px',
  large: '70px',
  extraLarge: '80px',
};

export const ImageContainer = Box.withConfig<{ $size?: ImageSize }>(({ $size }) => ({
  padding: 0,
  margin: 0,
  marginRight: 3,
  height: $size ? ImageSizeMap[$size] : ImageSizeMap.medium,
  width: $size ? ImageSizeMap[$size] : ImageSizeMap.medium,
  // for quantity badge positioning
  position: 'relative',
  justifyContent: 'center',
}));

export const DetailsContainer = VStack.withConfig({
  flexShrink: 1,
  alignSelf: 'center',
  justifyContent: 'flex-start',
  flex: 1,
});

export const QuantityBadge = HStack.withConfig({
  position: 'absolute',
  background: primitive.$bbqBrown,
  height: 5,
  color: 'white',
  borderRadius: 'full',
  // offset over image borders a bit
  top: '-3px',
  left: '-3px',
  alignItems: 'center',
});

export const ProductName = ({
  $isProductNameBold,
  ...props
}: React.ComponentPropsWithoutRef<typeof Typography> & { $isProductNameBold?: boolean }) =>
  React.createElement(Typography, {
    variant: $isProductNameBold ? 'headerThree' : 'copyOne',
    m: '$0',
    numberOfLines: 2,
    ...props,
  });

export const ProductDescription = withTypography({ variant: 'copyTwo', m: '$0' });

export const Layout = Box.withConfig<{ $inline?: boolean }>(({ $inline }) => ({
  flexDirection: $inline ? 'row' : 'column',
  justifyContent: $inline ? 'flex-start' : 'center',
  alignItems: 'flex-start',
  flex: 1,
}));

export const SelectionsListItem = Box.withConfig({
  _text: {
    variant: 'copyTwo',
  },
});

export const actionButtonStyles: ComponentProps<typeof ActionButton> = {
  margin: 0,
  padding: 0,
  alignSelf: 'flex-start',
  _text: {
    textDecorationLine: 'underline',
  },
};
